import { useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { createStripesSource } from "../utils/createStripesSource";
import { fetchCoEditionRequests, } from "../api/coEditionRequestService";
import { DEFAULT_PAGE_SIZE } from "../utils/constants";
export var CO_EDITION_REQUESTS_QUERY_KEY = "co-edition-requests";
export var useCoEditionRequestsData = function (filters, pageSize) {
    var _a;
    if (pageSize === void 0) { pageSize = DEFAULT_PAGE_SIZE; }
    var ky = useOkapiKy();
    var _b = useState(0), pageOffset = _b[0], setPageOffset = _b[1];
    var _c = useState(0), totalRecords = _c[0], setTotalRecords = _c[1];
    var _d = useQuery([CO_EDITION_REQUESTS_QUERY_KEY, filters, pageOffset, pageSize], function () {
        return fetchCoEditionRequests(ky, {
            statuses: filters.statuses,
            offset: pageOffset,
            limit: pageSize,
        });
    }, {
        keepPreviousData: true,
        onSuccess: function (res) { var _a; return setTotalRecords((_a = res.totalRecords) !== null && _a !== void 0 ? _a : 0); },
    }), data = _d.data, isLoading = _d.isLoading, isError = _d.isError, refetch = _d.refetch;
    var coEditionRequestsData = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
    var fetchMoreData = function (offset) {
        setPageOffset(offset);
    };
    var resetPageOffset = function () { return setPageOffset(0); };
    var source = createStripesSource({
        ky: ky,
        data: coEditionRequestsData,
        totalRecords: totalRecords,
        isLoading: isLoading,
        isError: isError,
        isLoaded: !isLoading,
        fetchMore: function () { return fetchMoreData(pageOffset + pageSize); },
    });
    return {
        coEditionRequestsData: coEditionRequestsData,
        totalRecords: totalRecords,
        isLoading: isLoading,
        isError: isError,
        refetch: refetch,
        fetchMoreData: fetchMoreData,
        resetPageOffset: resetPageOffset,
        source: source,
        pageOffset: pageOffset,
        pageSize: pageSize,
    };
};
